import { useEffect, useState } from 'react';
import useSize from './useSize';

const useLayout = (ref, breakpoint) => {
  const [isNarrowLayout, setIsNarrowLayout] = useState(true);
  const documentSize = useSize(ref);
  useEffect(() => {
    setIsNarrowLayout(documentSize < breakpoint);
  }, [documentSize]);

  return isNarrowLayout;
};

export default useLayout;
